export default "__VITE_ASSET__D1fl_I$p__"